function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import $ from 'dom7';
import { document } from 'ssr-window';
import Utils from '../../utils/utils';
import Framework7Class from '../../utils/class';
var openedModals = [];
var dialogsQueue = [];

function clearDialogsQueue() {
  if (dialogsQueue.length === 0) return;
  var dialog = dialogsQueue.shift();
  dialog.open();
}

var Modal = /*#__PURE__*/function (_Framework7Class) {
  _inherits(Modal, _Framework7Class);

  var _super = _createSuper(Modal);

  function Modal(app, params) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _super.call(this, params, [app]);

    var modal = _assertThisInitialized(_this);

    var defaults = {}; // Extend defaults with modules params

    modal.useModulesParams(defaults);
    modal.params = Utils.extend(defaults, params);
    modal.opened = false; // Install Modules

    modal.useModules();
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Modal, [{
    key: "onOpen",
    value: function onOpen() {
      var modal = this;
      modal.opened = true;
      openedModals.push(modal);
      $('html').addClass("with-modal-".concat(modal.type.toLowerCase()));
      modal.$el.trigger("modal:open ".concat(modal.type.toLowerCase(), ":open"));
      modal.emit("local::open modalOpen ".concat(modal.type, "Open"), modal);
    }
  }, {
    key: "onOpened",
    value: function onOpened() {
      var modal = this;
      modal.$el.trigger("modal:opened ".concat(modal.type.toLowerCase(), ":opened"));
      modal.emit("local::opened modalOpened ".concat(modal.type, "Opened"), modal);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var modal = this;
      modal.opened = false;
      if (!modal.type || !modal.$el) return;
      openedModals.splice(openedModals.indexOf(modal), 1);
      $('html').removeClass("with-modal-".concat(modal.type.toLowerCase()));
      modal.$el.trigger("modal:close ".concat(modal.type.toLowerCase(), ":close"));
      modal.emit("local::close modalClose ".concat(modal.type, "Close"), modal);
    }
  }, {
    key: "onClosed",
    value: function onClosed() {
      var modal = this;
      if (!modal.type || !modal.$el) return;
      modal.$el.removeClass('modal-out');
      modal.$el.hide();
      modal.$el.trigger("modal:closed ".concat(modal.type.toLowerCase(), ":closed"));
      modal.emit("local::closed modalClosed ".concat(modal.type, "Closed"), modal);
    }
  }, {
    key: "open",
    value: function open(animateModal) {
      var modal = this;
      var app = modal.app;
      var $el = modal.$el;
      var $backdropEl = modal.$backdropEl;
      var type = modal.type;
      var animate = true;
      if (typeof animateModal !== 'undefined') animate = animateModal;else if (typeof modal.params.animate !== 'undefined') {
        animate = modal.params.animate;
      }

      if (!$el || $el.hasClass('modal-in')) {
        return modal;
      }

      if (type === 'dialog' && app.params.modal.queueDialogs) {
        var pushToQueue;

        if ($('.dialog.modal-in').length > 0) {
          pushToQueue = true;
        } else if (openedModals.length > 0) {
          openedModals.forEach(function (openedModal) {
            if (openedModal.type === 'dialog') pushToQueue = true;
          });
        }

        if (pushToQueue) {
          dialogsQueue.push(modal);
          return modal;
        }
      }

      var $modalParentEl = $el.parent();
      var wasInDom = $el.parents(document).length > 0;

      if (app.params.modal.moveToRoot && !$modalParentEl.is(app.root)) {
        app.root.append($el);
        modal.once("".concat(type, "Closed"), function () {
          if (wasInDom) {
            $modalParentEl.append($el);
          } else {
            $el.remove();
          }
        });
      } // Show Modal


      $el.show();
      /* eslint no-underscore-dangle: ["error", { "allow": ["_clientLeft"] }] */

      modal._clientLeft = $el[0].clientLeft; // Modal

      function transitionEnd() {
        if ($el.hasClass('modal-out')) {
          modal.onClosed();
        } else if ($el.hasClass('modal-in')) {
          modal.onOpened();
        }
      }

      if (animate) {
        if ($backdropEl) {
          $backdropEl.removeClass('not-animated');
          $backdropEl.addClass('backdrop-in');
        }

        $el.animationEnd(function () {
          transitionEnd();
        });
        $el.transitionEnd(function () {
          transitionEnd();
        });
        $el.removeClass('modal-out not-animated').addClass('modal-in');
        modal.onOpen();
      } else {
        if ($backdropEl) {
          $backdropEl.addClass('backdrop-in not-animated');
        }

        $el.removeClass('modal-out').addClass('modal-in not-animated');
        modal.onOpen();
        modal.onOpened();
      }

      return modal;
    }
  }, {
    key: "close",
    value: function close(animateModal) {
      var modal = this;
      var $el = modal.$el;
      var $backdropEl = modal.$backdropEl;
      var animate = true;
      if (typeof animateModal !== 'undefined') animate = animateModal;else if (typeof modal.params.animate !== 'undefined') {
        animate = modal.params.animate;
      }

      if (!$el || !$el.hasClass('modal-in')) {
        if (dialogsQueue.indexOf(modal) >= 0) {
          dialogsQueue.splice(dialogsQueue.indexOf(modal), 1);
        }

        return modal;
      } // backdrop


      if ($backdropEl) {
        var needToHideBackdrop = true;

        if (modal.type === 'popup') {
          modal.$el.prevAll('.popup.modal-in').each(function (index, popupEl) {
            var popupInstance = popupEl.f7Modal;
            if (!popupInstance) return;

            if (popupInstance.params.closeByBackdropClick && popupInstance.params.backdrop && popupInstance.backdropEl === modal.backdropEl) {
              needToHideBackdrop = false;
            }
          });
        }

        if (needToHideBackdrop) {
          $backdropEl[animate ? 'removeClass' : 'addClass']('not-animated');
          $backdropEl.removeClass('backdrop-in');
        }
      } // Modal


      $el[animate ? 'removeClass' : 'addClass']('not-animated');

      function transitionEnd() {
        if ($el.hasClass('modal-out')) {
          modal.onClosed();
        } else if ($el.hasClass('modal-in')) {
          modal.onOpened();
        }
      }

      if (animate) {
        $el.animationEnd(function () {
          transitionEnd();
        });
        $el.transitionEnd(function () {
          transitionEnd();
        });
        $el.removeClass('modal-in').addClass('modal-out'); // Emit close

        modal.onClose();
      } else {
        $el.addClass('not-animated').removeClass('modal-in').addClass('modal-out'); // Emit close

        modal.onClose();
        modal.onClosed();
      }

      if (modal.type === 'dialog') {
        clearDialogsQueue();
      }

      return modal;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var modal = this;
      if (modal.destroyed) return;
      modal.emit("local::beforeDestroy modalBeforeDestroy ".concat(modal.type, "BeforeDestroy"), modal);

      if (modal.$el) {
        modal.$el.trigger("modal:beforedestroy ".concat(modal.type.toLowerCase(), ":beforedestroy"));

        if (modal.$el.length && modal.$el[0].f7Modal) {
          delete modal.$el[0].f7Modal;
        }
      }

      Utils.deleteProps(modal);
      modal.destroyed = true;
    }
  }]);

  return Modal;
}(Framework7Class);

export default Modal;